module.exports = __webpack_public_path__ + "static/media/gekodb.4f03893b.png";